import {initWebComponent} from "@/helpers/web-component-helper";
import {disableMoveLayer} from "@/helpers/ol/map/ol-move-helper";
import {hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {refreshLayer} from "@/helpers/ol/ol-layer-helper";
import {getDataTableByFormIDAndFeatureID} from "@/helpers/datatable/datatable-standalone-editor-helper";
import {initPopper} from "@/modules/popper";

export class LayerInfoInfoItemMutationStandaloneEditGeometryCancelComponent extends HTMLElement {
    constructor(){
        super();
        const template = document.createElement('template');
        const formID = this.getAttribute('data-form-id')
        const featureID = this.getAttribute('data-feature-id')

        template.innerHTML = `
<button class="btn btn-sm icon-btn btn-secondary btn-sm popper-header text-transform-none">
    <span class="fa fa-times"></span>
    <div class="popper-tooltip" role="tooltip" data-popper-placement="bottom">
         Annuleren
        <div class="arrow" data-popper-arrow=""></div>
     </div>
</button>
`
        initWebComponent(this, template)

        initPopper()

        this.addEventListener('click', () => {
            disableMoveLayer()
            hideElementsBySelector('layer-info-info-mutation-standalone-edit-geometry-save')
            hideElementsBySelector('layer-info-info-mutation-standalone-edit-geometry-cancel')
            refreshLayer(getDataTableByFormIDAndFeatureID(formID, featureID).BookmarkPresentationID)
        })
    }
}
